import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, Observable, Subject, Subscription } from 'rxjs';
import { environment } from '@environments/environment';

import Parse from 'parse';

import { ToastModule } from 'primeng/toast';

import { InitializeUser } from '@stores/user/user.actions';
import { SetInitalizedSite } from '@stores/site/site.actions';
import { UserState } from '@stores/user';

@Component({
  selector: 'tr-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private store: Store = inject(Store);

  private destroy$ = new Subject<void>();

  currentUser$: Observable<Parse.User | null | undefined> = this.store.select(UserState.getCurrentUser);

  userSubscription: Subscription | undefined;

  constructor() {}

  ngOnInit(): void {
    Parse.initialize(environment.parse.appId, environment.parse.javascriptKey);
    Parse.serverURL = 'https://parseapi.back4app.com/';
    // Seasonal and all-time Member objects share ids but hold different stats,
    // so each instance needs its own state instead of the SDK's shared-per-id state
    (Parse.Object as any).disableSingleInstance();

    this.store.dispatch(new InitializeUser());

    this.userSubscription = this.store
      .select(UserState.getCurrentUser)
      .pipe(filter((user): user is Parse.User => !!user))
      .subscribe((user: Parse.User) => {
        if (typeof (user as any).getUsername === 'function') {
          setTimeout(() => {
            this.store.dispatch(new SetInitalizedSite());
          }, 2000);
        }
      });

    // (async () => {
    //   await Parse.Cloud.run('createSnapshot', { orgId: 'vxknvw2RFX' });
    // })();
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }
}
